<script setup lang="ts">
import TransportsWrapper from '@/components/transports/TransportsWrapper.vue';
import { RoleGroups } from '@/constants/Roles';

definePage({
  name: 'TransportsRoot',
  meta: {
    title: 'layout.transports',
    roles: RoleGroups.Transports
  }
});
</script>

<template>
  <TransportsWrapper />
</template>

<style scoped>

</style>